import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=52eac9cf&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"
import style0 from "./strategy.vue?vue&type=style&index=0&id=52eac9cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eac9cf",
  null
  
)

export default component.exports